import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import apihostname from "../../services/apihostname";
import farmerMasterservice from "../../services/farmermaster.service";
// import moment from "moment/min/moment-with-locales";

import moment from "moment";
import "moment/locale/th";

moment.locale("th");
import {
  Page,
  Text,
  Document,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";

import logo from "../../assets/img/LOGO_OCSB.png";
import backGroundImage from "../../assets/img/ocsb_Da5_icon_a4.png";

Font.register({
  family: "THSarabun",
  fonts: [
    { src: apihostname + "/fonts/THSarabun.ttf" }, // font-style: normal, font-weight: normal
    { src: apihostname + "/fonts/THSarabunBold.ttf", fontStyle: "bold" },
  ],
});
// Create styles
const styles = StyleSheet.create({
  logo: {
    marginVertical: 15,
    marginHorizontal: 200,
  },
  pageBackground: {
    position: "absolute",
    marginVertical: 0,
    marginHorizontal: 0,
    width: "600px",
    height: "700px",
    zIndex: 9999,
    opacity: 0,
  },
  page: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 60,
    fontFamily: "THSarabun",
  },
  header: {
    fontSize: 18,
    marginBottom: 20,
    textAlign: "center",
    color: "black",
    fontFamily: "THSarabun",
    fontStyle: "bold",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 180,
    borderWidth: 2,
    borderColor: "black",
  },
  title: {
    fontSize: 16,
    textAlign: "left",
    fontFamily: "THSarabun",
    fontStyle: "bold",
  },
  text: {
    margin: 0,
    fontSize: 16,
    fontFamily: "THSarabun",
    fontStyle: "normal",
  },
});

// Create Document Component
const FarmerMasterDocument = (props) => {
  const [farmer, setFarmer] = useState({});
  useEffect(() => {
    farmerMasterservice
      .getMasterPrintPdf(props.master_id)
      .then((response) => {
        if (response.data.success) {
          setFarmer(response.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [props.master_id]);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image style={styles.pageBackground} src={backGroundImage} />
        <Image style={styles.logo} src={logo} />
        <Text style={styles.header} fixed>
          ~ บัตรหัวหน้ากลุ่มชาวไร่อ้อยชั่วคราว ~
        </Text>
        <Image
          style={styles.image}
          src={apihostname + "/images/farmer/" + farmer.farmer_image}
        />
        <Text style={styles.title}>
          เลขประจำตัวหัวหน้ากลุ่มชาวไร่อ้อย :{" "}
          <Text style={styles.text}>{farmer.farmer_card}</Text>
        </Text>
        <Text style={styles.title}>
          เลขบัตรประชาชน :{" "}
          <Text style={styles.text}>{farmer.masteridcard}</Text>
        </Text>
        <Text style={styles.title}>
          ชื่อ - นามสกุล: <Text style={styles.text}>{farmer.mastername}</Text>
        </Text>
        <Text style={styles.title}>
          เพศ : <Text style={styles.text}>{farmer.farmer_gender}</Text>
        </Text>
        <Text style={styles.title}>
          วันเกิด :{" "}
          <Text style={styles.text}>
            {moment(farmer.farmer_birthday)
              .add(543, "year")
              .locale("th")
              .format("ll")}
          </Text>
        </Text>
        <Text style={styles.title}>
          เบอร์โทรศัพท์ : <Text style={styles.text}>{farmer.farmer_phone}</Text>
        </Text>
        <Text style={styles.title}>
          ที่อยู่ : <Text style={styles.text}>{farmer.address}</Text>
        </Text>
        <Text style={styles.title}>
          วันที่จดทะเบียน :{" "}
          <Text style={styles.text}>
            {moment(farmer.created_at)
              .add(543, "year")
              .locale("th")
              .format("ll")}
          </Text>
        </Text>
        <Text style={styles.title}>
          ผู้จดทะเบียน : <Text style={styles.text}>{farmer.username}</Text>
        </Text>
        <Text style={styles.title}>
          ลายเซ็นผู้จดทะเบียน :{" "}
          <Text style={styles.text}>..............................</Text>
        </Text>
      </Page>
    </Document>
  );
};

export default FarmerMasterDocument;
FarmerMasterDocument.propTypes = {
  master_id: PropTypes.number,
};
